module.exports = __webpack_public_path__ + "img/ps-delito.0923daf8.jpg";